(function($){

// ---------- APP START
var App = {

  config: {
		scrollOffset: 100
  },

	init: function(){
    //$.fn.matchHeight._maintainScroll = true;
    // Init SVG polyfill
    if(typeof(svg4everybody) !== 'undefined') svg4everybody();
    // Init object-fill polyfill
    if(typeof(objectFitImages) !== 'undefined') objectFitImages();

    // Remove focus state when clicking on a button with a mouse
    $(':not(form) button, a').on('click', function(e){
      if(e.clientX && e.clientY)
        $(this).blur();
    });
		
		
		// Tac link hashtag
    $('li.rgpd a').on('click', function () {
      tarteaucitron.userInterface.openPanel();
    });

    $('a[href^="#"]').on('click', function(e){
      e.preventDefault();
      var scrollTo = $(this).data('scroll-to') ? $(this).data('scroll-to') : $(this).attr('href');

      if($(scrollTo).length > 0 && ($(this).data('prevent-scroll') !== true) && !$(this).data('vc-container')) {
        App.scroll(scrollTo, $(this).data('scroll-offset'));
			}
    });

    if($('[data-scroll]').length){
      App.scroll($('[data-scroll]').data('scroll'));
    }
		
		$(window).scroll(function() {
			App.shrinkBody();
		});
		
		AOS.init({duration: 750});
		
		App.current_anim 		= null;
		App.current_product = null;
		
		App.checkToolsStatus();
		App.shrinkBody();
		App.initMenu();
		App.initFaq();
		App.initSlider();
		App.initProduct();
		App.ctaProducts();
		
		if($('.slider-home').length) App.initHomeSlider();
		
		$('.js-menu-toggle').on('click touch', function () {
			$('body').toggleClass('is-overlayed');
		});
		
		$('.js-bigmenu-close').on('click touch', function () {
			$('body').removeClass('is-overlayed');
		});
		
		$('.js-btn-accessy').on('click touch', function () {
			if($('body').hasClass('mode-accessy')) {
				$('body').removeClass('mode-accessy');
				App.localStorage('accessy', null);
			}
			else {
				$('body').addClass('mode-accessy');
				App.localStorage('accessy', 'on');				
			}
		});
		
		$('.js-btn-lowtech').on('click touch', function () {
			if($('body').hasClass('mode-lowtech')) {
				$('body').removeClass('mode-lowtech');
				App.localStorage('lowtech', null);
			}
			else {
				$('body').addClass('mode-lowtech');
				App.localStorage('lowtech', 'on');				
			}
		});
		
		$('.js-btn-anim').on('mouseover', function () {
			$(this).removeClass('off').addClass('on');
		});
		
		$('.js-btn-anim').on('mouseout', function () {
			$(this).removeClass('on').addClass('off');
		});
		
		$('.js-btn-lowtech-alt').on('click touch', function (e) {
			e.preventDefault();
			$(this).closest('figure').addClass('view');		
		});
		
		$('.js-recipe-data').on('click touch', function (e) {
			e.preventDefault();
			$('.recipe-data--outer').toggleClass('active');
		});
  },
	
  /*load: function(){
  },*/

  scroll: function(element, offset){
    offset = offset === undefined ? App.config.scrollOffset : offset;
    $('html, body').clearQueue().animate({ scrollTop: $(element).offset().top - offset}, 'slow');
  },

  checkToolsStatus: function(){
		if(App.localStorage('accessy') == 'on') $('body').addClass('mode-accessy');
		else $('body').removeClass('mode-accessy');
		if(App.localStorage('lowtech') == 'on') $('body').addClass('mode-lowtech'); 
		else $('body').removeClass('mode-lowtech');
		$('.btn-switch-slider').removeClass('onload');
  },
	
	shrinkBody : function() {
		var $scroll = $(window).scrollTop();
		if ($scroll >= 70) {
			$('body').addClass('is-shrink');
		} else{
			$('body').removeClass('is-shrink');
		}
	},
	
	initMenu: function() {
		$('.menu-item-product').on('mouseover', function (e) {
			var $thumb = $(this).data('media');
			$('#js-submenu2').html('<figure><img src="'+$thumb+'" alt=""></figure>');			
		});
		
		$('.menu-item-product').on('mouseout', function (e) {
			$('#js-submenu2').empty();			
		});		
	},
	
	initHomeSlider: function() {		
		var $slider = new Swiper(".slider-home", {
			slidesPerView: 1,
			speed: 200,
			spaceBetween: 0,
			longSwipesRatio: 0.2,
			loop: true,
			autoplay: {
				delay: 4800,
				disableOnInteraction: false
			},
			mousewheel: {
        forceToAxis: true
			},
			pagination: {
      	el: '.swiper-pagination',
				clickable: true
			},
			on: {
				afterInit: function(swiper) {
					var first_id = $('.swiper-slide')[0].id;
					App.animHomeSlider(first_id);
				}
			}
		});
		
		// activeIndexChange
		$slider.on('transitionEnd', function () {
      var $activeIndex = this.activeIndex;
			App.animHomeSlider(this.slides[$activeIndex].id);
			if(null !== App.current_anim)  {
				App.current_anim.destroy();
			}
    });		
	},
	
	animHomeSlider: function(product) {
		var $product_id =  product.substr(product.length - 1);
		var $slide_id 	= 'anim-' + product;
		var $slide 			= document.getElementById($slide_id);
		var $url 				= $($slide).data('url');
		var animSlide = {
			container: $slide,
			renderer: "svg",
			loop: false,
			autoplay: true,
			path: getPath($product_id)
		};
		
		var anim = lottie.loadAnimation(animSlide);
		
		// We need to set svg positionning on top right;
		anim.addEventListener("config_ready", function(){
			$svg = $slide.childNodes[0];
			$svg.setAttribute('preserveAspectRatio', 'xMaxYMax meet');
			
			$('.product-header-bg').removeClass(App.current_product).addClass(product);
			
			$($slide).on('click touch', function () {
				window.location.href = $url;
			});
			
			App.current_anim = anim;
			App.current_product = product;
		});
		
		function getPath (product_id) {
			var $base_url = '/themes/mapopote/assets/anims/slider';
			var ww = $(window).width();
			var $json_path = (ww <= 768) ? '-m' : '';
			return $base_url + product_id + $json_path  + '/slider' + product_id + '.json';	
		}
	},
	
	initProduct: function() {
		var $base_url = '/themes/mapopote/assets/anims/plate';
		$('.product__anim').each(function(index, element) {
			var $anim_id 		= element.id;
			var $product_id = $anim_id.substr($anim_id.length - 1);
			var $anim 			= document.getElementById($anim_id);
			var animSlide = {
				container: $anim,
				renderer: "svg",
				loop: false,
				autoplay: false,
				path: $base_url + $product_id + '/plate' + $product_id + '.json'
			};
			
			var anim = lottie.loadAnimation(animSlide);
			
			document.addEventListener('aos:in', function(e) {
				if(e.detail.id == 'plate-animate') {
					lottie.play();
				}
			});
			
			document.addEventListener('aos:out', function(e) {
				if(e.detail.id == 'plate-animate') {
					lottie.goToAndStop(0);
				}
			});
		});
	},
	
	initSlider: function() {	
		var $autoplay, $nav;	
		if($('.slider-faq').length) {
			new Swiper(".slider-faq", {
				slidesPerView: 1,
				speed: 400,
				spaceBetween: 12,
				breakpoints: {
					// when window width is >= 480px
					992: {
						slidesPerView: 2,
						spaceBetween: 30
					}
				}
			});
		}
		
		$('.slider').each(function(index, element) {
			
			var $nav = element.getElementsByClassName('swiper-pagination');			
			var $autoplay = $(element).hasClass('slider-products') ? {delay: 2000, disableOnInteraction: false}: false;
			
			if($(element).hasClass('slider-recipes')) {
				new Swiper(element, {
					slidesPerView: 3.3,
					speed: 400,
					spaceBetween: 20,
					centerInsufficientSlides: true,
					autoplay: $autoplay,
					pagination: {
						el: $nav[0],
						clickable: true
					},
					breakpoints: {
						320: {
							slidesPerView: 1
						},
						480: {
							slidesPerView: 2,
							spaceBetween: 30
						},
						1024: {
							slidesPerView: 3.3,
							spaceBetween: 40
						}
					}
				});
			}
			
			else {
			
				new Swiper(element, {
					slidesPerView: 4.3,
					speed: 400,
					spaceBetween: 20,
					centerInsufficientSlides: true,
					autoplay: $autoplay,
					pagination: {
						el: $nav[0],
						clickable: true
					},
					breakpoints: {
						320: {
							slidesPerView: 1
						},
						480: {
							slidesPerView: 2,
							spaceBetween: 30
						},
						1024: {
							slidesPerView: 4.3,
							spaceBetween: 40
						}
					}
				});
			}
    });
	},
	
	initFaq: function() {
		$('.tab-label').on('click touch', function (e) {
			e.preventDefault();
			var $parent = $(this).parent();
			$('.tab').not($parent).removeClass('active');
			$parent.toggleClass('active');
		});
	},
	
	ctaProducts: function() {
		var $target = $('.products-popin');	
		var $url = '/wordpress/wp-admin/admin-ajax.php?action=get_products';
		$('.js-products-cta').on('click touch', function (e) {
			if($(window).width() < 440) {
				e.preventDefault();
				$.ajax({
					type: 'GET',
					url: $url,
					dataType: 'json',
					success: function(data){
						$target.html(data);
						$target.toggleClass('active');	
						$('.js-popin-close').on('click touch', function (e) {
							$target.removeClass('active');
							$('body').removeClass('is-overlayed');
						});											
					}		
				});
			}
		});
	},
	
	localStorage: function(key, value) {
    if (localStorage == null) {
      return console.log('Local storage not supported!');
    } else {
      try {
        if (typeof value != 'undefined') {
          localStorage.setItem(key, value);
          result = value;
        } else {
          result = (value === null) ? localStorage.removeItem(key) :
            localStorage.getItem(key);
        }
        return result;
      } catch(err) {
        private_browsing_error = 'Unable to store local data. Are you using Private Browsing?';
       // $exceed.test(err) ? alert(private_browsing_error) : throwerror(err);
      }
    }
  },
		
  gevt: function(action, category, value) {
		App.gtagOrNot('event', action, {
			'event_category': category.event_category,
			'event_label': category.event_label,
			'value': value
		});
  },
	
	gtagOrNot: function () {
    if (typeof window.gtag == 'function') {
      window.gtag.apply(null, arguments);
    }
  }
};
// ---------- APP END

// Init app
$(document).ready(App.init);
$(window).on('load', App.load); // jQuery 3
window.App = App;
window.gevt = App.gevt;
})(jQuery);